<template>
  <div class="top-header-container">
    <div class="top-header">
      <h1>查询系统 - {{ menuTitle }}</h1>

      <!-- 自定义版本菜单，不依赖layui的默认交互 -->
      <div class="version-menu-wrapper">
        <button class="version-btn" @mouseenter="showMenu" @click="toggleMenu">
          当前版本：【{{ currentVersionName || '请选择版本' }}】
        </button>
        <!-- 使用动态类代替v-show，以便添加平滑过渡 -->
        <div
            class="version-dropdown-menu"
            :class="{ 'menu-visible': menuVisible }"
            @mouseenter="showMenu"
            @mouseleave="hideMenu"
        >
          <template v-if="versionData.length">
            <div
                v-for="version in versionData"
                :key="version.c_id"
                class="version-item"
                @click="handleVersionClick(version)"
            >
              选择版本【{{ version.c_name }}】
            </div>
          </template>
          <template v-else>
            <div class="version-item disabled">
              暂无版本数据
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuTitle: {
      type: String,
      required: true,
      default: '物品查询'
    },
    versionData: {
      type: Array,
      default: () => []
    },
    // 当前选择的版本ID
    currentVersionId: {
      type: [Number, String],
      default: null
    },
    // 当前选择的版本名称
    currentVersionName: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      menuVisible: false,
      hideTimeout: null,
    };
  },
  methods: {
    handleVersionClick(version) {
      try {
        if (version && version.c_id !== undefined && version.c_id !== null) {
          // 获取当前路由信息
          const currentPath = this.$route.path;
          const currentCId = this.$route.query.c_id;

          // 检查是否是重复导航到同一页面和同一版本
          if (currentPath === '/detail' && currentCId === String(version.c_id)) {
            this.hideMenu(); // 点击后隐藏菜单
            return;
          }

          // 跳转到对应版本详情页
          this.$router.push({
            path: '/detail',
            query: {c_id: version.c_id}
          }).catch(err => {
            // 忽略NavigationDuplicated错误，但记录其他类型的错误
            if (!err.message.includes('Avoided redundant navigation')) {
              console.error('路由跳转异常:', err);
            }
          });

          this.hideMenu(); // 点击后隐藏菜单
        } else {
          console.error('无效的版本数据:', version);
        }
      } catch (error) {
        console.error('跳转版本详情页失败:', error);
      }
    },
    // 显示菜单
    showMenu() {
      // 清除之前的定时器
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.menuVisible = true;
    },
    // 隐藏菜单
    hideMenu() {
      // 设置一个短暂的延迟再隐藏菜单，避免鼠标快速移动时的闪烁问题
      this.hideTimeout = setTimeout(() => {
        this.menuVisible = false;
      }, 200);
    },
    // 切换菜单显示状态（用于点击按钮时）
    toggleMenu() {
      if (this.menuVisible) {
        this.hideMenu();
      } else {
        this.showMenu();
      }
    }
  },
  watch: {
    // versionData(newVal) {
    //   //console.log('TopHeader版本数据更新:', newVal);
    // }
  },
  beforeDestroy() {
    // 清理定时器防止内存泄漏
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }
};
</script>

<style scoped>
/* 重置所有样式，避免与layui冲突 */
.top-header-container {
  position: relative;
  width: 100%;
}

.top-header {
  background: #222b45;
  color: white;
  padding: 15px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.top-header h1 {
  font-size: 22px;
  margin: 0;
  position: relative;
  z-index: 1;
}

/* 版本菜单容器 */
.version-menu-wrapper {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000; /* 确保菜单位于顶层 */
}

/* 版本菜单按钮 */
.version-btn {
  background-color: #222b45;
  border: none;
  color: white;
  border-radius: 4px;
  font-size: 14px;
  padding: 6px 12px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.2s, transform 0.15s ease;
}

.version-btn:hover {
  background-color: #4a5a8c;
}

.version-btn:focus {
  outline: 2px solid #5a6abf;
  outline-offset: 2px;
}

.version-btn:active {
  transform: scale(0.98);
}

/* 下拉菜单样式 - 添加过渡效果 */
.version-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 5px;
  background-color: #222b45;
  border: 1px solid #3a476f;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  min-width: 160px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 999;
  /* 添加padding避免鼠标离开时立即隐藏 */
  padding: 2px;

  /* 初始状态：透明、缩放、隐藏 */
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
  visibility: hidden;
  pointer-events: none;
  /* 添加过渡动画 */
  transition:
      opacity 0.25s ease,
      transform 0.25s ease,
      visibility 0.25s ease;
}

/* 菜单可见时的样式 */
.version-dropdown-menu.menu-visible {
  opacity: 1;
  transform: translateY(0) scale(1);
  visibility: visible;
  pointer-events: auto;
}

/* 菜单项样式 */
.version-item {
  padding: 10px 15px;
  cursor: pointer;
  color: white;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background-color 0.2s, transform 0.1s ease;
  border-radius: 3px;
  margin: 1px 0;
}

.version-item:hover {
  background-color: #3a476f;
  transform: translateX(2px);
}

.version-item:active {
  transform: translateX(1px);
}

.version-item.disabled {
  color: #ccc;
  cursor: not-allowed;
}

.version-item.disabled:hover {
  background-color: transparent;
  transform: none;
}

/* 响应式样式 */
@media (max-width: 576px) {
  .top-header h1 {
    font-size: 18px;
  }

  .version-btn {
    font-size: 12px;
    padding: 4px 8px;
  }

  .version-dropdown-menu {
    min-width: 140px;
    right: 0;
    left: auto;
  }
}

/* 自定义滚动条样式 */
.version-dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.version-dropdown-menu::-webkit-scrollbar-track {
  background: #1a2035;
  border-radius: 3px;
}

.version-dropdown-menu::-webkit-scrollbar-thumb {
  background: #4a5a8c;
  border-radius: 3px;
}

.version-dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #5a6abf;
}
</style>